import React from "react";
import PropTypes from "prop-types";

export default class LittleLoader extends React.Component {
  static propTypes = {
    promise: PropTypes.object,
    busy: PropTypes.bool,
    error: PropTypes.bool,
  };

  componentWillMount() {
    this.componentDidUpdate({});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.promise !== this.props.promise) {
      this._promise = this.props.promise;
      if (this._promise && this._promise.then) {
        this.setState({ done: false, busy: true, error: false });
        this._promise
          .then(
            () =>
              this._promise === this.props.promise &&
              this.setState({ busy: false }),
          )
          .catch(
            (ex) =>
              this._promise === this.props.promise &&
              this.setState({ error: ex }),
          );
      }
    }
  }

  load(busy) {
    this._promise = busy;
    if (this._promise && this._promise.then) {
      this.setState({ done: false, busy: true, error: false });
      this._promise
        .then(() => this.setState({ busy: false }))
        .catch((ex) => this.setState({ error: ex }));
    }
  }

  render() {
    let state = (this._promise ? this.state : this.props) || {};
    let cls =
      (this.props.className || "") +
      " little-loader " +
      (state.done ? "done" : "");
    if (state.error) cls += " failed";
    else if (state.busy) cls += " busy";

    return (
      <div className="relative" style={{ width: "20px", height: "20px" }}>
        <div
          onClick={() => state.error && this.setState({ done: true })}
          className={cls}
        />
      </div>
    );
  }
}
